import React, { useState, useEffect } from 'react';
import { getProducts, getThemes, getFragrances, getTestimonials } from '../../api/adminApi';

function DashboardPage() {
  const [stats, setStats] = useState({
    products: 0,
    themes: 0,
    fragrances: 0,
    testimonials: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [products, themes, fragrances, testimonials] = await Promise.all([
        getProducts(),
        getThemes(),
        getFragrances(),
        getTestimonials()
      ]);

      const fragranceCount = fragrances.reduce((acc, cat) => acc + cat.fragrances.length, 0);

      setStats({
        products: products.length,
        themes: themes.length,
        fragrances: fragranceCount,
        testimonials: testimonials.length
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const StatCard = ({ title, value, icon, color }) => (
    <div style={{
      backgroundColor: 'white',
      padding: '1.5rem',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}>
      <div>
        <p style={{ color: '#7f8c8d', fontSize: '0.875rem', marginBottom: '0.5rem' }}>{title}</p>
        <p style={{ fontSize: '2rem', fontWeight: 'bold', color: color }}>{value}</p>
      </div>
      <div style={{ fontSize: '3rem' }}>{icon}</div>
    </div>
  );

  if (loading) {
    return <div>Chargement...</div>;
  }

  return (
    <div>
      <h1 style={{ marginBottom: '2rem', color: '#2c3e50' }}>Tableau de bord</h1>
      <div style={{
        margin: '2rem 0',
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ marginBottom: '1rem' }}>Bienvenue dans l'administration</h2>
        <p style={{ color: '#7f8c8d' }}>
          Utilisez le menu de gauche pour gérer vos produits, thèmes, senteurs et avis clients.
        </p>
      </div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '1.5rem'
      }}>
        <StatCard
          title="Produits"
          value={stats.products}
          icon="🕯️"
          color="#9c6f44"
        />
        <StatCard
          title="Thèmes"
          value={stats.themes}
          icon="🎨"
          color="#3498db"
        />
        <StatCard
          title="Senteurs"
          value={stats.fragrances}
          icon="🌸"
          color="#e74c3c"
        />
        <StatCard
          title="Avis clients"
          value={stats.testimonials}
          icon="⭐"
          color="#f39c12"
        />
      </div>
    </div>
  );
}

export default DashboardPage;
